import Entity from '../../utilities/entity';

class TrainingAttachment extends Entity {

}

export default new TrainingAttachment();